import icsChromelyRequest from '@icreate/ics-chromely-js-sdk'
import IndexExamine from './index-examine'
import { escapeSpecialCharacters } from './utils'

export default class DictDrugBaseIndex {
  private static like = ['ID', 'NAME', 'ALIAS', 'SPELL_CODE', 'STROKE_CODE']
  private static exact = {}

  /**
   * 查询药品基础目录
   * @param category：分类,药品分类
   * @param keys：关键字
   * @returns 成功返回结果
   */
  public static query(category: string, keys: string = ''): Promise<any> {
    if (icsChromelyRequest.isChromely) {
      return IndexExamine.query(
        'DictDrugBaseIndex',
        '',
        this.QueryCondition(escapeSpecialCharacters(keys), category)
      )
    } else {
      return IndexExamine.queryByServer('DictDrugBaseIndex', category, keys, this.like, this.exact)
    }
  }

  /**
   * 分页查询药品基础目录
   * @param indexId: 索引id
   * @param pageIndex：page索引
   * @param pageSize：page尺寸
   * @param category：分类,药品分类
   * @param keys：关键字
   * @returns 成功返回结果
   */
  public static page(
    pageIndex: number,
    pageSize: number,
    category: string,
    keys: string = ''
  ): Promise<any> {
    if (icsChromelyRequest.isChromely) {
      return IndexExamine.page(
        'DictDrugBaseIndex',
        pageIndex,
        pageSize,
        '',
        this.QueryCondition(escapeSpecialCharacters(keys), category)
      )
    } else {
      return IndexExamine.pageByServer(
        'DictDrugBaseIndex',
        pageIndex,
        pageSize,
        category,
        keys,
        this.like,
        this.exact
      )
    }
  }

  /**
   * 查询条件组装
   * @param keys
   * @param category
   * @returns
   */
  private static QueryCondition(keys: string, category: string): string {
    let condition = []
    if (keys.trim()) {
      condition.push(
        `(id:*${keys}* OR name:"*${keys}*" OR alias:"*${keys}*" OR spellCode:*${keys}* OR strokeCode:*${keys}*)`
      )
    }
    if (category.trim()) {
      condition.push(`category:${category}`)
    }
    return condition.join(' AND ')
  }
}
